import { PrizeFormType } from 'entities/prize/model';

export const PrizeDataToFormData = (data: PrizeFormType) => {
  const formData = new FormData();

  formData.append(
    'name',
    JSON.stringify({
      ru: data.name_ru,
      kz: data.name_kz,
      uz: data.name_uz,
      kg: data.name_kg,
    }),
  );
  formData.append(
    'description',
    JSON.stringify({
      ru: data.description_ru,
      kz: data.description_kz,
      uz: data.description_uz,
      kg: data.description_kg,
    }),
  );
  formData.append('category', data.category as string);
  formData.append('image', data.image as File);
  formData.append('icon', data.icon as File);
  formData.append('is_generated', String(data.is_generated));
  if (data.min_start_date) {
    formData.append('start_date', data.min_start_date as string);
  }
  if (data.max_end_date) {
    formData.append('end_date', data.max_end_date as string);
  }
  if (data.prize_file) {
    formData.append('prize_file', data.prize_file as File);
  }

  return formData;
};
